export default __webpack_public_path__ + "static/media/Chanderi-Fort.1ffa024e.jpg";